export const buildPageTitle = (title: string) => {
  return `${title} | Rakeback Wizard`
}
